import { LanguageISO6391 } from 'ai-constants'
import { getI11nInstance, initializeI11n } from './i18n'

export type Translate = (
  word: string,
  variables?: Record<string, unknown>,
  fallback?: string,
) => string

export const buildTranslate = (
  lang: LanguageISO6391,
  instance = initializeI11n(),
): Translate => {
  const fixedTranslate = instance.getFixedT(lang, 'common')

  return (word, variables, fallback) => {
    const translation = fixedTranslate(word, {
      ...variables,
      defaultValue: fallback || word,
    })

    return typeof translation === 'string' ? translation : fallback || word
  }
}

export const t = (
  word: string,
  variables?: Record<string, unknown>,
  lang: LanguageISO6391 = 'es',
): string => {
  return buildTranslate(lang)(word, variables)
}

export const getCurrentLanguage = () => {
  const instance = getI11nInstance()

  return (instance.resolvedLanguage ||
    instance.language ||
    'es') as LanguageISO6391
}
